/*
  Café Public — cartes produits : choix de la mouture au clic (octobre 2026)

  Cartes concernées : quick-buy[data-cp-mouture-card] (produit avec une option « Mouture »,
  voir snippets/quick-buy.liquid). La rangée Mouture y est masquée (assets/cp-cartes.css).

  Au clic sur « Ajouter au panier » :
  - au moins 2 moutures disponibles pour le format choisi (ex. 250 g) : un panneau
    « Quelle mouture ? » s'ouvre sur l'image ; un choix sélectionne la variante et
    l'ajoute au panier avec la logique du thème (component-quick-buy.js) ;
  - une seule mouture possible (ex. 1 kg, grains entiers seulement) : ajout direct.
  Après l'ajout, la carte revient à la mouture par défaut (la première disponible).

  Carte étroite (moins de 240 px, ex. mobile en 2 colonnes) : le panneau s'ouvre en bas de l'écran
  (feuille + fond assombri) plutôt que sur l'image, pour garder des boutons confortables.
*/
(function () {
  'use strict';

  if (window.cpMoutureInit) return;
  window.cpMoutureInit = true;

  var CARD = 'quick-buy[data-cp-mouture-card]';
  var SHEET_BELOW = 240; // largeur de carte (px) sous laquelle le panneau devient une feuille en bas d'écran
  var TEXT = {
    title: 'Quelle mouture ?',
    close: 'Fermer',
    groundPrefix: 'Moulu : +'
  };

  var uid = 0;
  var current = null; // { qb, form, card, panel, backdrop, sheet, trigger }

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function money(pv, cents) {
    try {
      return String(pv._formatMoney(cents, window.KROWN.settings.shop_money_format)).trim();
    } catch (err) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' $';
    }
  }

  /* Valeur choisie et liste des valeurs d'une rangée d'option (pastilles ou menu) */
  function rowControls(row) {
    var select = row.querySelector('select[data-js-product-variant-container]');
    if (select) {
      return {
        values: toArray(select.options).filter(function (o) { return o.hasAttribute('value'); }).map(function (o) { return o.value; }),
        selected: select.value || null,
        set: function (value) {
          if (select.value === value) return true;
          select.value = value;
          if (select.value !== value) return false;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          return true;
        }
      };
    }
    var inputs = toArray(row.querySelectorAll('.product-variant__input'));
    var checked = inputs.filter(function (i) { return i.checked; })[0];
    return {
      values: inputs.map(function (i) { return i.value; }),
      selected: checked ? checked.value : null,
      set: function (value) {
        var input = inputs.filter(function (i) { return i.value === value; })[0];
        if (!input) return false;
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return true;
      }
    };
  }

  /* État d'une carte : moutures disponibles pour les autres options choisies */
  function getState(qb) {
    var pv = qb.querySelector('product-variants');
    if (!pv) return null;

    var rows = toArray(pv.querySelectorAll('[data-js-product-variant]'));
    var mIndex = -1;
    rows.forEach(function (row, i) {
      if (row.hasAttribute('data-cp-mouture')) mIndex = i;
    });
    if (mIndex < 0) return null;

    var variants;
    try {
      variants = typeof pv.getVariantData === 'function'
        ? pv.getVariantData()
        : JSON.parse(pv.querySelector('script[type="application/json"]').textContent);
    } catch (err) {
      return null;
    }

    var controls = rows.map(rowControls);
    var selected = controls.map(function (c) { return c.selected; });
    var mouture = controls[mIndex];

    var matching = variants.filter(function (v) {
      return v.available && v.options.every(function (o, i) {
        return i === mIndex || o === selected[i];
      });
    });

    var choices = [];
    mouture.values.forEach(function (value) {
      var variant = matching.filter(function (v) { return v.options[mIndex] === value; })[0];
      if (variant) choices.push({ value: value, variant: variant });
    });

    return { pv: pv, mIndex: mIndex, mouture: mouture, selected: selected, choices: choices };
  }

  function resetMouture(qb) {
    var state = getState(qb);
    if (state && state.choices.length && state.mouture.selected !== state.choices[0].value) {
      state.mouture.set(state.choices[0].value);
    }
  }

  function submitForm(form) {
    var button = form.querySelector('[type="submit"]');
    form.dataset.cpBypass = '1';
    try {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(button || undefined);
      } else if (button) {
        button.click();
      } else {
        form.submit();
      }
    } finally {
      delete form.dataset.cpBypass;
    }
  }

  function place() {
    if (!current || current.sheet) return;
    var card = current.card;
    var panel = current.panel;
    var image = card.querySelector('[data-js-product-item-image]') || card;
    var cardBox = card.getBoundingClientRect();
    var box = image.getBoundingClientRect();
    var top = Math.round(box.top - cardBox.top);
    panel.style.top = top + 'px';
    panel.style.left = Math.round(box.left - cardBox.left) + 'px';
    panel.style.width = Math.round(box.width) + 'px';
    panel.style.minHeight = Math.round(box.height) + 'px';
    panel.style.maxHeight = Math.max(Math.round(cardBox.height - top), Math.round(box.height)) + 'px';
  }

  function closePanel(returnFocus) {
    if (!current) return;
    var c = current;
    current = null;
    if (c.panel.parentNode) c.panel.parentNode.removeChild(c.panel);
    if (c.backdrop && c.backdrop.parentNode) c.backdrop.parentNode.removeChild(c.backdrop);
    if (c.trigger) {
      c.trigger.removeAttribute('aria-expanded');
      if (returnFocus) c.trigger.focus({ preventScroll: true });
    }
  }

  function choose(value) {
    if (!current) return;
    var qb = current.qb;
    var form = current.form;
    var state = getState(qb);
    if (!state || !state.mouture.set(value)) return;

    var variant = state.pv.currentVariant;
    if (!variant || !variant.available || variant.options[state.mIndex] !== value) {
      resetMouture(qb);
      closePanel(true);
      return;
    }

    closePanel(true);
    submitForm(form);
    // Le thème a déjà lu le formulaire (synchrone) : la carte revient à la mouture par défaut.
    resetMouture(qb);
  }

  function openPanel(qb, form, state) {
    closePanel(false);

    var card = qb.closest('[data-js-product-item]');
    var trigger = form.querySelector('[data-js-product-add-to-cart]');
    if (!card) {
      submitForm(form);
      return;
    }

    var sheet = card.getBoundingClientRect().width < SHEET_BELOW;
    var id = 'cp-mouture-' + (++uid);
    var panel = document.createElement('div');
    panel.className = 'cp-mouture-panel' + (sheet ? ' cp-mouture-panel--sheet' : '');
    panel.id = id;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-labelledby', id + '-title');

    var head = document.createElement('div');
    head.className = 'cp-mouture-panel__head';

    var titles = document.createElement('div');
    var title = document.createElement('p');
    title.className = 'cp-mouture-panel__title text-size--small';
    title.id = id + '-title';
    title.textContent = TEXT.title;
    titles.appendChild(title);

    if (sheet) {
      // En bas d'écran, rappeler le produit et le format choisi
      var name = card.querySelector('.product-item__title');
      var formats = state.selected.filter(function (v, i) { return i !== state.mIndex && v; });
      var subtitle = document.createElement('p');
      subtitle.className = 'cp-mouture-panel__subtitle';
      subtitle.textContent = [name ? name.textContent.trim() : ''].concat(formats).filter(Boolean).join(' · ');
      titles.appendChild(subtitle);
    }

    // Écart de prix : une note « Moulu : +1,00 $ » si toutes les moutures coûtent le même supplément,
    // sinon le prix sous chaque choix.
    var reference = state.choices[0];
    var deltas = state.choices.slice(1).map(function (c) { return c.variant.price - reference.variant.price; });
    var sameDelta = deltas.length > 0 && deltas.every(function (d) { return d === deltas[0]; });
    var showNote = sameDelta && deltas[0] > 0 && /grain/i.test(reference.value);
    var showPrices = !showNote && state.choices.some(function (c) { return c.variant.price !== reference.variant.price; });

    if (showNote) {
      var note = document.createElement('p');
      note.className = 'cp-mouture-panel__note';
      note.textContent = TEXT.groundPrefix + money(state.pv, deltas[0]);
      titles.appendChild(note);
    }
    head.appendChild(titles);

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'cp-mouture-panel__close';
    close.setAttribute('aria-label', TEXT.close);
    var symbol = window.KROWN && window.KROWN.settings && window.KROWN.settings.symbols && window.KROWN.settings.symbols.close;
    if (symbol) {
      close.innerHTML = symbol;
      var svg = close.querySelector('svg');
      if (svg) svg.setAttribute('aria-hidden', 'true');
    } else {
      close.textContent = '×';
    }
    close.addEventListener('click', function () { closePanel(true); });
    head.appendChild(close);
    panel.appendChild(head);

    var list = document.createElement('div');
    list.className = 'cp-mouture-panel__options';
    state.choices.forEach(function (choice) {
      var option = document.createElement('button');
      option.type = 'button';
      option.className = 'cp-mouture-panel__option text-size--small';
      option.setAttribute('data-value', choice.value);
      var label = document.createElement('span');
      label.textContent = choice.value;
      option.appendChild(label);
      if (showPrices) {
        var price = document.createElement('span');
        price.className = 'cp-mouture-panel__price';
        price.textContent = money(state.pv, choice.variant.price);
        option.appendChild(price);
      }
      option.addEventListener('click', function () { choose(choice.value); });
      list.appendChild(option);
    });
    panel.appendChild(list);

    var backdrop = null;
    if (sheet) {
      backdrop = document.createElement('div');
      backdrop.className = 'cp-mouture-backdrop';
      document.body.appendChild(backdrop);
      document.body.appendChild(panel);
    } else {
      card.appendChild(panel);
    }
    current = { qb: qb, form: form, card: card, panel: panel, backdrop: backdrop, sheet: sheet, trigger: trigger };
    place();

    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var first = list.querySelector('button');
    if (first) first.focus({ preventScroll: true });
  }

  /* Clic sur « Ajouter au panier » (ou Entrée) dans une carte avec mouture */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || typeof form.closest !== 'function') return;
    var qb = form.closest(CARD);
    if (!qb) return;

    if (form.dataset.cpBypass === '1') {
      delete form.dataset.cpBypass;
      return;
    }

    if (current && current.form === form) {
      e.preventDefault();
      e.stopPropagation();
      var first = current.panel.querySelector('.cp-mouture-panel__option');
      if (first) first.focus({ preventScroll: true });
      return;
    }

    var state = getState(qb);
    if (!state) return;

    if (state.choices.length < 2) {
      // Une seule mouture possible pour ce format : on s'assure qu'elle est choisie, le thème ajoute.
      if (state.choices.length === 1 && state.mouture.selected !== state.choices[0].value) {
        state.mouture.set(state.choices[0].value);
      }
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    openPanel(qb, form, state);
  }, true);

  /* Changement de format : fermer le panneau, garder une combinaison qui existe */
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;
    var qb = target.closest(CARD);
    // Seulement les choix d'options (pas le champ caché « id » que le thème met à jour)
    if (!qb || !target.closest('product-variants') || target.closest('[data-cp-mouture]')) return;

    if (current && current.qb === qb) closePanel(false);

    var state = getState(qb);
    if (!state || !state.choices.length) return;
    var ok = state.choices.some(function (c) { return c.value === state.mouture.selected; });
    if (!ok) state.mouture.set(state.choices[0].value);
  });

  document.addEventListener('keydown', function (e) {
    if (current && (e.key === 'Escape' || e.key === 'Esc')) {
      e.preventDefault();
      closePanel(true);
    }
  });

  document.addEventListener('pointerdown', function (e) {
    if (!current) return;
    if (current.panel.contains(e.target)) return;
    if (current.trigger && current.trigger.contains(e.target)) return;
    closePanel(false);
  }, true);

  document.addEventListener('focusin', function (e) {
    if (!current) return;
    if (current.panel.contains(e.target)) return;
    if (current.trigger && current.trigger.contains(e.target)) return;
    closePanel(false);
  });

  window.addEventListener('resize', function () {
    if (current) place();
  });

  window.addEventListener('pageshow', function () {
    closePanel(false);
  });
})();